import { keyframes, styled } from "styled-components";

const animationSpin = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    rotate: 360deg;
  }
`;

const animationShowHide = keyframes`
  0% {
    opacity: 1;
  }

  50%,
  100% {
    opacity: 0;
  }
`;

const Root = styled.div`
  inset: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  
  .left,
  .right,
  .spinner {
    position: absolute;
  }

  .left {
    animation-duration: ${props => props.$duration && props.$duration}s;
    animation-name: ${animationShowHide};
    animation-timing-function: steps(1, end);
    background-color: var(--color-theme-primary-400);
    border-radius: 100% 0 0 100%/ 50% 0 0 50%;
    inset: 0 50% 0 0;
    opacity: 1;
    z-index: 3;
  }

  .right {
    animation-direction: reverse;
    animation-duration: ${props => props.$duration && props.$duration}s;
    animation-name: ${animationShowHide};
    animation-timing-function: steps(1, end);
    background-color: var(--color-theme-accent-500);
    border-radius: 0 100% 100% 0 / 0 50% 50% 0;
    inset: 0 0 0 50%;
    opacity: 0;
    z-index: 1;
  }

  .spinner {
    animation-duration: ${props => props.$duration && props.$duration}s;
    animation-name: ${animationSpin};
    animation-timing-function: linear;
    background-color: var(--color-theme-accent-500);
    border-radius: 100% 0 0 100% / 50% 0 0 50%;
    inset: 0 50% 0 0;
    overflow: hidden;
    transform-origin: center right;
    z-index: 2;
  }
`;

function PieLoader({ duration }) {
 return (
  <Root $duration={duration}>
    <div className="left"></div>
    <div className="spinner"></div>
    <div className="right"></div>
  </Root>
 )
}

export default PieLoader;